import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-keyboard-shortcuts',
    templateUrl: './keyboard-shortcuts.component.html',
    styleUrl: './keyboard-shortcuts.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeyboardShortcutsComponent {
    constructor(protected dialogRef: MatDialogRef<KeyboardShortcutsComponent>) {
    }

}
